export const SET_BELEG_TYPEN = "setBelegTyp";
export const SET_KONTO = "setKonto";
export const SET_WAEHRUNG = "setWaehrung";
export const SET_KOSTENSTELLE = "setKostenstelle";
